import request from "@/util/http";
/**
 * 添加
 */
export function add(params) {
	return request({
		url: '/upms/shop/goods_favorite/add',
		method: 'post',
		params: params,
	})
}


/**
 * 列表
 */
export function list(params) {
	return request({
		url: '/upms/shop/goods_favorite/list',
		method: 'get',
		params: params,
	})
}


/**
 * 列表
 */
export function list_json(params) {
	return request({
		url: '/upms/shop/goods_favorite/list_json',
		method: 'get',
		params: params,
	})
}


/**
 * 删除
 */
export function del(ids) {
	return request({
		url: '/upms/shop/goods_favorite/delete?ids=' + ids,
		method: 'delete',
	})
}

// module.exports = {
// 	add,
// 	list,
// 	list_json,
// 	del,
// }
